<div class="col-12 p-0" *ngIf="manageNotification">
    <div class="notificationManage col-12 p-0">
        <span class="pointer-cursor" (click)="clickToBack()">&#60; Back</span>
    </div>
    <div class="col-12 p-0">
        <div class="row mx-0 pt-1" *ngFor="let list of activeNotifications; let i = index">
            <div class="col-1 pl-0 pr-1" *ngIf="list.supplierName!=null">
                <i class="material-icons pt-1 pointer-cursor" style="font-size: 18px;"
                (click)="onEditClick(list, i)">edit</i></div>
            <div class="col-10 pl-0 panel-notification-content edit-sup-tag" *ngIf="list.supplierName!=null">{{list.supplierName + ' ' + list.organizationCode}}</div>
        </div>
    </div>
    <div class="col-12 px-0 pt-3">
        <button mat-stroked-button type="button" class="sg-primary-stroked mat-stroked-button"
            (click)="addManageNotification()">Add</button>
    </div>
</div>

<!--edit notification start-->
<div class="col-12 p-0 add-Notification" *ngIf="addNotification && editForm">
    <div class="notificationManage col-12 p-0 pb-3">
        <span class="pointer-cursor" (click)="backToNotificationManage()">&#60; Back</span>
    </div>
    <form [formGroup]="notificationForm" novalidate autocomplete="off">
        <div class="row mx-0">
        <div class="col-10 p-0">
            <label class="sg-supllier-number1">For Supplier: <span 
                    class="sg-form-field-required-marker ng-star-inserted">*</span> </label>
            <mat-form-field appearance="outline" class="w-100" [disabled]="editForm || disableBasedOnRole">
                <mat-select placeholder="{{editForm || disableBasedOnRole ? supplierValueSet : All}}" formControlName="supplier"
                 (selectionChange)="onSupplierChange($event)"
                 name="show" class="sg-select-sup">
                    <mat-option *ngFor="let opt of suppliersList" [value]="opt">
                        {{opt.supplierName + ' ' + opt.organizationCode}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-error class="error-font-size" *ngIf="notificationForm.controls['supplier'].hasError('inUserExists')">
                The selected Supplier has already been added.
              </mat-error>
        </div>
        </div>

        <div class="row mx-0 pb-1">
            <label class="sg-supllier-number1">Notify me when a document</label>
            <div class="col-12 p-0">
                <mat-checkbox formControlName="uploaded" class="my-2">Is Uploaded</mat-checkbox>
            </div>
        </div>

        <div class="row mx-0 p-0 pb-3">
            <label class="sg-supllier-number1">Notification Type: <span _ngcontent-bts-c300=""
                    class="sg-form-field-required-marker ng-star-inserted">*</span></label>
            <div class="col-12 p-0">
                <mat-checkbox formControlName="inAppNotification" class="d-block">In-app notifications (show only in application)
                </mat-checkbox>
                <mat-checkbox formControlName="emailNotification" class="d-block" (change)="emailCheckOnChange()">Email notifications</mat-checkbox>
                <div class="col-12 ml-2" *ngIf="emailNotification.value == true">
                    <div>
                        <mat-checkbox formControlName="perDocument" >Per Document</mat-checkbox>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 p-0">
            <label class="sg-supllier-number1">Notify me for the following Document types: </label>
            <mat-radio-group aria-label="Select an option" formControlName="documentType" [(ngModel)]="defaultChecked">
                <div class="row mx-0 pb-1" *ngFor="let opt of docType">
                    <mat-radio-button  [value]="opt.id">{{opt.value}}</mat-radio-button>
                </div>
            </mat-radio-group>
        </div>
        <div class="row mx-0 p-0 pt-2" *ngIf="isAllDocSelected">
            <div class="col-1 pr-0 pt-2 ml-3">
            <label class="sg-supllier-number1 float-right pt-1">Search: </label>
            </div>
            <div class="col-10">
                <mat-form-field appearance="outline" class="w-100 input-value-uppercase">
                    <input matInput formControlName="search"
                                    type="text"
                                    placeholder="Search Folder or Document Type" 
                                    aria-label="Name" 
                                    [matAutocomplete]="auto" maxlength="30"
                                    (focusout)="checkDocumentExist()">
                  </mat-form-field>
                  <mat-autocomplete #auto="matAutocomplete"
                    (optionSelected)="onAddClick($event.option.value)">
                    <mat-option *ngFor="let docType of options" [value]="docType.documentTypeString">
                      {{docType.documentTypeString}}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-error class="error-font-size" *ngIf="notificationForm.controls['search'].hasError('doesNotExists')">
                    This Folder/Document doesn't exist.
                  </mat-error>
            </div>
        </div>
        <div class="row p-0 pl-4" *ngIf="isAllDocSelected">
            <label class="sg-supllier-number1 w-100">You are subscribed to: </label>
            <div class="row mx-0 w-100" *ngFor="let list of subscribedList;let i=index">
                <div class="col-1 p-0 pointer-cursor">
                    <i class="material-icons pt-1" (click)="onCrossClick(i)">close</i>
                </div>
                <div class="col-11 pl-0 pt-2">
                    {{list.documentType}}
                </div>
            </div>
        </div>
    </form>
</div>
<!--add edit notification end-->

<!--multi-supplier add flow start-->
<div class="col-12 p-0 add-Notification" *ngIf="addNotification && !editForm">

    <!-- Step 1: select suppliers -->
    <div *ngIf="addStep === 1">
        <div class="notificationManage col-12 p-0 pb-3">
            <span class="pointer-cursor" (click)="backToNotificationManage()">&#60; Back</span>
        </div>
        <label class="sg-supllier-number1">Select Suppliers: <span
                class="sg-form-field-required-marker ng-star-inserted">*</span></label>
        <mat-form-field appearance="outline" class="w-100 input-value-uppercase">
            <input matInput [formControl]="supplierSearch" type="text"
                placeholder="Search or type a Supplier name" aria-label="Search Suppliers" autocomplete="off">
        </mat-form-field>
        <div class="row mx-0 pb-2">
            <mat-checkbox [checked]="allSuppliersChecked" (change)="toggleAllSuppliers($event.checked)"
                [disabled]="filteredSuppliers.length === 0">All Suppliers</mat-checkbox>
        </div>
        <div class="sg-supplier-select-list">
            <div class="row mx-0 pb-1" *ngFor="let opt of filteredSuppliers">
                <mat-checkbox [checked]="isSupplierSelected(opt)" (change)="toggleSupplier(opt)">
                    {{opt.supplierName + ' ' + opt.organizationCode}}
                </mat-checkbox>
            </div>
            <div class="row mx-0 pb-1" *ngIf="filteredSuppliers.length === 0">
                <span class="sg-supllier-number1">No suppliers available to add.</span>
            </div>
        </div>
    </div>

    <!-- Step 2: per-supplier configuration -->
    <div *ngIf="addStep === 2">
        <div class="notificationManage col-12 p-0 pb-3">
            <span class="pointer-cursor" (click)="backToSupplierStep()">&#60; Back to Suppliers</span>
        </div>
        <form [formGroup]="configForm" novalidate autocomplete="off">
            <div formArrayName="configs">
                <mat-accordion multi="true">
                    <mat-expansion-panel *ngFor="let cfg of configs.controls; let i = index" [formGroupName]="i"
                        [expanded]="configs.length === 1">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="edit-sup-tag">
                                {{cfg.get('supplierName').value + ' ' + cfg.get('organizationCode').value}}
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <div class="row mx-0 pb-1">
                            <label class="sg-supllier-number1">Notify me when a document</label>
                            <div class="col-12 p-0">
                                <mat-checkbox formControlName="uploaded" class="my-2">Is Uploaded</mat-checkbox>
                            </div>
                        </div>

                        <div class="row mx-0 p-0 pb-3">
                            <label class="sg-supllier-number1">Notification Type: <span
                                    class="sg-form-field-required-marker ng-star-inserted">*</span></label>
                            <div class="col-12 p-0">
                                <mat-checkbox formControlName="inAppNotification" class="d-block">In-app notifications
                                    (show only in application)</mat-checkbox>
                                <mat-checkbox formControlName="emailNotification" class="d-block"
                                    (change)="onConfigEmailChange(i)">Email notifications</mat-checkbox>
                                <div class="col-12 ml-2" *ngIf="cfg.get('emailNotification').value === true">
                                    <div>
                                        <mat-checkbox formControlName="perDocument">Per Document</mat-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 p-0">
                            <label class="sg-supllier-number1">Notify me for the following Document types: </label>
                            <mat-radio-group aria-label="Select an option" formControlName="documentType"
                                (change)="onConfigDocModeChange(i)">
                                <div class="row mx-0 pb-1" *ngFor="let opt of docType">
                                    <mat-radio-button [value]="opt.id">{{opt.value}}</mat-radio-button>
                                </div>
                            </mat-radio-group>
                        </div>

                        <div class="row mx-0 p-0 pt-2" *ngIf="cfg.get('documentType').value === 1">
                            <div class="col-1 pr-0 pt-2 ml-3">
                                <label class="sg-supllier-number1 float-right pt-1">Search: </label>
                            </div>
                            <div class="col-10">
                                <mat-form-field appearance="outline" class="w-100 input-value-uppercase">
                                    <input matInput formControlName="search" type="text"
                                        placeholder="Search Folder or Document Type" aria-label="Name"
                                        [matAutocomplete]="auto" maxlength="30">
                                </mat-form-field>
                                <mat-autocomplete #auto="matAutocomplete"
                                    (optionSelected)="addConfigDocType(i, $event.option.value)">
                                    <mat-option *ngFor="let docTypeOption of docOptionsByIndex[i]"
                                        [value]="docTypeOption.documentTypeString">
                                        {{docTypeOption.documentTypeString}}
                                    </mat-option>
                                </mat-autocomplete>
                            </div>
                        </div>
                        <div class="row p-0 pl-4" *ngIf="cfg.get('documentType').value === 1">
                            <label class="sg-supllier-number1 w-100">You are subscribed to: </label>
                            <div class="row mx-0 w-100" *ngFor="let list of selectedDocsByIndex[i]; let di = index">
                                <div class="col-1 p-0 pointer-cursor">
                                    <i class="material-icons pt-1" (click)="removeConfigDocType(i, di)">close</i>
                                </div>
                                <div class="col-11 pl-0 pt-2">
                                    {{list.documentType}}
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </form>
    </div>
</div>
<!--multi-supplier add flow end-->